import { render } from "./ExternalMcpServerCatalogDialog.vue?vue&type=template&id=07d4e633&scoped=true&ts=true"
import script from "./ExternalMcpServerCatalogDialog.vue?vue&type=script&lang=ts"
export * from "./ExternalMcpServerCatalogDialog.vue?vue&type=script&lang=ts"

import "./ExternalMcpServerCatalogDialog.vue?vue&type=style&index=0&id=07d4e633&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d4e633"]])

export default __exports__